export const formatDecimal = value => value % 1 === 0 ? value : value.toFixed(2).replace('.', ',')

const MEAL_COST_OPTIONS = {
  FULL: {value: 'FULL', text: 'Completa'},
  HALF: {value: 'HALF', text: 'Media'},
  NONE: {value: 'NONE', text: 'Ninguna'}
}
export const translateMealCost = value => MEAL_COST_OPTIONS[value].text

const TYPE_OPTIONS = {
  PROJECT: {value: 'PROJECT', text: 'Ordinario'},
  ADM: {value: 'ADM', text: 'ADM'}
}
export const translateType = value => TYPE_OPTIONS[value].text

const STATUS_OPTIONS = {
  PENDING_FIRST_VALIDATION: {value: 'PENDING_FIRST_VALIDATION', text: 'Pendiente 1ª Validación'},
  PENDING_SECOND_VALIDATION: {value: 'PROPENDING_SECOND_VALIDATIONJECT', text: 'Pendiente 2ª Validación'},
  CONFIRMATED: {value: 'CONFIRMATED', text: 'Confirmado'}
}
export const translateStatus = value => STATUS_OPTIONS[value].text

export const yesOrNo = value => value ? 'Si' : 'No'



// WEBPACK FOOTER //
// ./src/formatters.js